module.exports = __webpack_public_path__ + "img/pesaj.c83ddae9.jpg";